module.exports = __webpack_public_path__ + "img/pek.aff0fef0.png";